import { render, staticRenderFns } from "./avaliar-coleta.vue?vue&type=template&id=7543bd5c&"
import script from "./avaliar-coleta.vue?vue&type=script&lang=js&"
export * from "./avaliar-coleta.vue?vue&type=script&lang=js&"
import style0 from "./avaliar-coleta.vue?vue&type=style&index=0&lang=css&"
import style1 from "./avaliar-coleta.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports